import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageContextService {
  readonly backLabelOverride = signal<string | null>(null);

  reset(): void {
    this.backLabelOverride.set(null);
  }
}
